import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IOrder {
    amount: number
    created_at: number
    exchange: string
    exchange_id: string
    id: string
    key_id: string
    market: string
    normalized_symbol: string
    order_type: string
    pnl: number
    position_entry_price: number
    position_side: string
    price: number
    price_in_base: number
    type: string
    user_id: string
    is_unknown: boolean
}

export const getNft = async (currentPage: number): Promise<ApiRes<IOrder[]>> => {
    return await apiGet(API_URL, `admin/upbit/nft?current_page=${currentPage}&page_size=${10}`)
}
